import * as React from 'react';

const Edit = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
        <path
            stroke="#161616"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9.166 3.334H3.333A1.667 1.667 0 0 0 1.666 5v11.667a1.666 1.666 0 0 0 1.667 1.666h11.666a1.667 1.667 0 0 0 1.667-1.666v-5.834"
        />
        <path
            stroke="#161616"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15.416 2.083a1.768 1.768 0 0 1 2.5 2.5L9.999 12.5l-3.333.833L7.499 10z"
        />
    </svg>
);
export default Edit;
